/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Checkbox.module.scss';

const Checkbox = ({
  id,
  name,
  checked = false,
  onChange = () => {},
  size,
  ...props
}) => {
  return (
    <div className={styles.checkboxContainer} style={{ height: size, width: size }}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        style={{ height: size, width: size }}
        {...props}
      />
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  size: PropTypes.number.isRequired,
};

export default Checkbox;
